<div class="drawer-content w-full">
    <mat-progress-bar mode="indeterminate" *ngIf="!currentRoute"></mat-progress-bar>
    <div class="route-details-header w-full" *ngIf="currentRoute">
        <div class="relative w-full pr-4 py-2 bg-accent-50 dark:bg-accent-700 z-0">
            <div class="flex items-center justify-between w-full">
                <div class="text-xl font-semibold title-font flex items-center space-x-1.5 flex-1"
                    [ngClass]="{'ml-4': parentModule === 'dispatch'}">
                    <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                        *ngIf="parentModule !== 'dispatch'" matTooltipPosition="above" tabindex="0"
                        (click)="drawerOpenedChanged(false)">
                        <i class="ti text-2xl mx-1 ti-arrow-narrow-left"></i>
                    </button>
                    <div *ngIf="currentRoute?.is_locked" class="mt-1 text-red-600" title="{{'dispatchBoard.scheduler.route.locked' | translate}}"><i class="ti ti-lock text-2xl"></i></div>
                    <h5>{{currentRoute?.route_name}} <span class="route-color min-w-3.5 mx-2" [ngStyle]="{'background': currentRoute?.color}"></span></h5>
                </div>
                <div class="flex space-x-2 items-center">
                    <!-- Route Actions -->
                    <button class="cursor-pointer" title="{{(currentRoute?.is_locked ? 'text.unlock_route' : 'text.lock_route')| translate }}"
                        (click)="toggleRouteLockState()" [ngClass]="{'mt-0.5': !currentRoute?.is_locked}">
                        <em class="ti ti-lock routeLockIcon" *ngIf="!currentRoute?.is_locked"></em>
                        <img class="h-5 w-5" src="/assets/images/svgs/lock_open.svg" alt=""
                            *ngIf="currentRoute?.is_locked" loading="lazy">
                    </button>
                    <div class="flex items-center">
                        <i class="ti ti-user-plus text-2xl mx-2" title="{{'assign.employee.title' | translate}}"
                            (click)="toggleAssignmentDrawer('assignEmployeeDrawer')" *ngIf="!currentRoute?.is_locked"></i>
                        <i class="ti ti-wand text-2xl mx-2 cursor-pointer" title="{{'optimise.route' | translate}}"
                            (click)="optimiseRoute()" *ngIf="!currentRoute?.is_optimized && !currentRoute?.is_locked && currentRoute?.jobs.length"></i>
                        <i class="ti ti-dots-vertical text-2xl ml-2" [matMenuTriggerFor]="mapRoutes"></i>
                        <mat-menu #mapRoutes>
                            <button *ngIf="utilityService.hasPermission('route.update') && !currentRoute?.is_locked" mat-menu-item
                                class="text-base h-10" (click)="toggleEditRoute()">
                                <mat-icon class="icon-size-5 text-current ti ti-pencil"></mat-icon>
                                {{'route.edit' | translate}}
                            </button>
                            <button *ngIf="utilityService.hasPermission('route.update') && !currentRoute?.is_locked && currentRoute?.jobs.length" mat-menu-item
                                class="text-base h-10" (click)="toggleReorderDrawer('reorderJobDrawer')">
                                <mat-icon class="icon-size-5 text-current ti ti-stack"></mat-icon>
                                {{'text.reorder_jobs' | translate }}
                            </button>
                            <button *ngIf="utilityService.hasPermission('route.clone')" mat-menu-item
                                (click)="toggleCloneRoute()" class="text-base h-10">
                                <mat-icon class="icon-size-5 text-current ti ti-copy"></mat-icon>
                                {{'text.clone_route' | translate}}
                            </button>
                            <button *ngIf="utilityService.hasPermission('route.update') && !currentRoute?.is_locked" mat-menu-item
                                (click)="deleteRoute()" class="text-base h-10 text-red-500">
                                <mat-icon class="icon-size-5 text-current ti ti-trash"></mat-icon>
                                {{'text.delete_route' | translate}}
                            </button>
                        </mat-menu>
                    </div>
                    <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                        *ngIf="parentModule === 'dispatch'" matTooltipPosition="above" tabindex="0"
                        (click)="drawerOpenedChanged(false)">
                        <i class="ti text-2xl mx-1 ti ti-x"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="route-details-main-container bg-white zuper-scrollbar" *ngIf="currentRoute">
        <div
            class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
            <nav class="-mb-px flex space-x-8 ml-4" aria-label="Tabs">
                <ng-container>
                    <a class="whitespace-nowrap flex items-center py-4 px-1 border-b-2 font-medium text-base cursor-pointer"
                        (click)="currentTab = 'PRIMARY'" [ngClass]="setTabClasses('PRIMARY')">
                        {{'text.primary_details' | translate}}
                    </a>
                    <a class="whitespace-nowrap flex items-center py-4 px-1 border-b-2 font-medium text-base cursor-pointer"
                        (click)="currentTab = 'JOBS'" [ngClass]="setTabClasses('JOBS')">
                        {{'text.jobs' | translate}}
                    </a>
                </ng-container>
            </nav>
        </div>
        <div *ngIf="currentTab === 'PRIMARY'" class="primary-container space-y-6">
            <!-- Mode of Transport -->
            <div class="grid grid-cols-6 m-4">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"text.mode_of_transport" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-user text-xl mr-1"></em>
                    <span class="text-base">
                        {{transportModeObj[currentRoute?.transport_mode] | translate}}
                    </span>
                </div>
            </div>


            <!-- Route Optimisation -->
            <div class="grid grid-cols-6 m-4">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"text.route_type" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-route text-xl mr-1"></em>
                    <span class="text-base">
                        {{routeOptimisationObj[currentRoute?.route_type] | translate}}
                    </span>
                </div>
            </div>


            <!-- Total Jobs -->
            <div class="grid grid-cols-6 m-4">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"text.no_of_jobs" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-briefcase text-xl mr-1"></em>
                    <span class="text-base">
                        {{currentRoute?.jobs?.length || 0}}
                    </span>
                </div>
            </div>

            <!-- Total Job Duration -->
            <div class="grid grid-cols-6 m-4"
                *ngIf="getTotalScheduledDurationHours(totalJobDuration) || utilityService.getMin(totalJobDuration)">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"label.total_job_duration" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-clock text-xl mr-1"></em>
                    <span class="text-base">
                        <span *ngIf="getTotalScheduledDurationHours(totalJobDuration)">
                            {{getTotalScheduledDurationHours(totalJobDuration)}} {{'route.hours' | translate}}
                        </span>
                        <span *ngIf="utilityService.getMin(totalJobDuration * 60)">
                            {{utilityService.getMin(totalJobDuration * 60)}} {{'route.min' | translate}}
                        </span>
                    </span>
                </div>
            </div>

            <!-- Total Distance -->
            <div class="grid grid-cols-6 m-4"
                *ngIf="utilityService.getDistance(currentRoute?.total_distance) && currentRoute?.total_distance">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"text.total_distance" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-timeline text-xl mr-1"></em>
                    <span class="text-base">
                        <span *ngIf="companyConfig?.general?.distance_metric === 'MILES'">
                            {{utilityService.getDistance(currentRoute?.total_distance)}} {{'route.distance.metric.miles'
                            | translate}}
                        </span>
                        <span *ngIf="companyConfig?.general?.distance_metric !== 'MILES'">
                            {{utilityService.getDistance(currentRoute?.total_distance)}}
                            {{'route.distance.metric.kilo_meters' | translate}}
                        </span>
                    </span>
                </div>
            </div>

            <!-- Total Time -->
            <div class="grid grid-cols-6 m-4"
                *ngIf="utilityService.getHours(currentRoute?.total_time) || utilityService.getMin(currentRoute?.total_time)">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{'label.total_time' | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-clock text-xl mr-1"></em>
                    <span class="text-base">
                        <span *ngIf="utilityService.getHours(currentRoute?.total_time)">
                            {{utilityService.getHours(currentRoute?.total_time)}} {{'route.hours' | translate}}
                        </span>
                        <span *ngIf="utilityService.getMin(currentRoute?.total_time)">
                            {{utilityService.getMin(currentRoute?.total_time)}} {{'route.min' | translate}}
                        </span>
                    </span>
                </div>
            </div>

            <!-- Departure -->
            <div class="grid grid-cols-6 m-4">
                <div class="col-span-2 break-words flex items-center text-base">
                    {{"text.departure" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-calendar text-xl mr-1"></em>
                    <span class="text-base">
                        <span>
                            {{currentRoute?.departure | datetime: dateTimeFormat: timezone}}
                        </span>
                    </span>
                </div>
            </div>

            <!-- Assigned To Field -->
            <div class="flex my-2.5 mx-4 primary-font" *ngIf="currentRoute.assigned_to?.length">
                <span class="w-1/3 text-base">{{'text.assigned_to' | translate}}</span>
                <div class="divide-y divide-gray-200 w-2/3 -mt-1.5">
                    <ng-container *ngFor="let user of getAssignedUsers()">
                        <div class="flex items-center py-0.5" *ngIf="user">
                            <div
                                class="flex flex-shrink-0 bg-gray-200 rounded-full items-center text-sm justify-center h-6 w-6 mr-2">
                                {{user?.first_name[0]}}
                            </div>
                            <div class="w-2/3 truncate">
                                <span class="text-base" matTooltip="{{user?.first_name}} {{user?.last_name ?? ''}}">
                                    {{user?.first_name}} {{user?.last_name ?? ''}}
                                </span>
                            </div>
                            <div class="flex ml-auto items-center">
                                <a href="mailto:{{user?.email}}" matTooltip="{{'email' | translate}}"
                                    class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-8 w-8 cursor-pointer"
                                    *ngIf="user?.email">
                                    <em class="ti ti-mail text-xl"></em>
                                </a>
                                <a href="tel:{{user?.mobile_phone_number || user?.work_phone_number || user?.home_phone_number}}"
                                    matTooltip="{{'text.contact' | translate}}"
                                    class="flex flex-shrink-0 hover:bg-gray-200 rounded-full items-center justify-center h-8 w-8 cursor-pointer"
                                    *ngIf="user?.mobile_phone_number || user?.work_phone_number || user?.home_phone_number">
                                    <em class="ti ti-phone text-xl"></em>
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Start Location -->
            <div class="grid grid-cols-6 m-4">
                <div class="col-span-2 break-words flex text-base">
                    {{"text.start_location" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-map-pin text-xl mr-1"></em>
                    <span class="text-base">
                        <span class="text-base  line-clamp">{{currentRoute?.routeStartAddress}}</span> <a class="text-primary-500 hover:underline"
                            href="{{this.utilityService.getMapsCoordinatesUrl(currentRoute?.start_location?.geo_cords[0], currentRoute?.start_location?.geo_cords[1])}}"
                            target="_blank">({{this.utilityService.getLocaleValue('text.view_on_map')}})</a>
                    </span>
                </div>
            </div>

            <!-- End Location -->
            <div class="grid grid-cols-6 m-4"
                *ngIf="currentRoute?.end_location?.street || currentRoute?.end_location?.name">
                <div class="col-span-2 break-words flex text-base">
                    {{"text.end_location" | translate}}
                </div>
                <div class="col-span-4 break-words">
                    <em class="ti ti-map-pin text-xl mr-1"></em>
                    <span class="text-base">
                        <span class="text-base  line-clamp">{{currentRoute?.routeEndAddress}}</span> <a class="text-primary-500 hover:underline"
                            href="{{this.utilityService.getMapsCoordinatesUrl(currentRoute?.end_location?.geo_cords[0], currentRoute?.end_location?.geo_cords[1])}}"
                            target="_blank">({{this.utilityService.getLocaleValue('text.view_on_map')}})</a>
                    </span>
                </div>
            </div>

        </div>
        <div *ngIf="currentTab === 'JOBS'">
            <div class="p-6 zuper-scrollbar" *ngIf="currentRoute" [ngClass]="{'pt-0': !(currentRoute?.start_location?.street || currentRoute?.start_location?.city), 'jobs-container-full': parentModule === 'dispatch', 'jobs-container': parentModule !== 'dispatch'}">
                <ol class="relative border-l dark:border-gray-700" [ngStyle]="{
                                'border-left-color': currentRoute?.color
                            }">
                    <li class="mb-10 ml-6">
                        <span
                            class="absolute flex items-center justify-center text-white w-6 h-6 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                            [ngStyle]="{
                                        'background-color': currentRoute?.color
                                    }">
                            <i class="ti ti-home-2"></i>
                        </span>
                        <div class="p-3 pt-4 border border-l-8 mb-6 cursor-pointer"
                            (click)="moveToLocation(currentRoute?.start_location)"
                            *ngIf="currentRoute?.start_location?.street" [ngStyle]="{
                                        'border-left-color': currentRoute?.color
                                    }">
                            <div>
                                <p class="text-base font-semibold">{{'text.start_location' | translate}}</p>
                                @if (currentRoute?.routeStartAddress) {
                                    <p class="text-base">{{currentRoute?.routeStartAddress}}</p>
                                }
                            </div>
                        </div>
                    </li>
                    <ng-container *ngIf="sequencedJobs?.length > 0">
                        <ng-container *ngFor="let job of sequencedJobs; let i = index">
                            <li class="mb-10 ml-6">
                                <div class="text-base relative bottom-5"  *ngIf="currentRoute?.start_location?.street || currentRoute?.start_location?.city">
                                    <span class="mr-3" *ngIf="job?.distance">
                                        <i class="ti ti-timeline text-2xl"></i>
                                        <span *ngIf="companyConfig?.general?.distance_metric === 'MILES'">
                                            {{utilityService.getDistance(job?.distance)}}
                                            {{'route.distance.metric.miles' | translate}}
                                        </span>
                                        <span *ngIf="companyConfig?.general?.distance_metric !== 'MILES'">
                                            {{utilityService.getDistance(job?.distance)}}
                                            {{'route.distance.metric.kilo_meters' | translate}}
                                        </span>
                                    </span>
                                    <em *ngIf="utilityService.getHours(job?.time) || utilityService.getMin(job?.time)"
                                        class="ti ti-clock text-xl"></em>
                                    <span class="text-base">
                                        <span *ngIf="+utilityService.getHours(job?.time)">
                                            {{utilityService.getHours(job?.time)}} {{'route.hours' | translate}}
                                        </span>
                                        <span *ngIf="+utilityService.getMin(job?.time)">
                                            {{utilityService.getMin(job?.time)}} {{'route.min' | translate}}
                                        </span>
                                    </span>
                                </div>
                                <span
                                    class="absolute flex items-center justify-center text-white w-6 h-6 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                                    [ngStyle]="{
                                                'background-color': currentRoute?.color
                                            }">
                                    {{i + 1}}
                                </span>
                                <div class="p-3 pt-4 border border-l-8 mb-6 relative cursor-pointer"
                                    (click)="moveToJob(job?.job)" [ngStyle]="{
                                                'border-left-color': job?.job?.current_job_status?.status_color || currentRoute?.color
                                            }">
                                    <div>
                                        <div class="flex justify-between primary-font text-base text-gray-700 font-normal">
                                            <p class="font-semibold">
                                                <i class="ti ti-repeat mr-2" *ngIf="job?.job?.is_recurrence"></i>
                                                #<span *ngIf="job?.job?.prefix">{{job?.job?.prefix}} </span><span
                                                    *ngIf="job?.job?.work_order_number">{{job?.job?.work_order_number}}
                                                </span>{{job?.job?.job_title}}
                                            </p>
                                            <i class="ti ti-dots-vertical text-2xl ml-2"
                                                [matMenuTriggerFor]="jobMenu"></i>
                                            <mat-menu #jobMenu>
                                                <button *ngIf="utilityService.hasModuleAccess('JOB')" mat-menu-item
                                                    class="text-base h-10" (click)="openJobDetail(job?.job)">
                                                    <mat-icon class="icon-size-5 text-current ti ti-eye"></mat-icon>
                                                    {{'view.job' | translate}}
                                                </button>
                                                <button
                                                    *ngIf="utilityService.hasPermission('route.update') && !currentRoute?.is_locked"
                                                    mat-menu-item class="text-base h-10"
                                                    (click)="openAssignToRoute(job?.job)">
                                                    <mat-icon
                                                        class="icon-size-5 text-current ti ti-git-pull-request"></mat-icon>
                                                    {{'text.assign.another_route' | translate }}
                                                </button>
                                                <button
                                                    *ngIf="utilityService.hasPermission('route.update') && !currentRoute?.is_locked"
                                                    (click)="removeFromRoute(job?.job)" mat-menu-item
                                                    class="text-base h-10 text-red-500">
                                                    <mat-icon class="icon-size-5 text-current ti ti-trash"></mat-icon>
                                                    {{'text.remove_from_route' | translate}}
                                                </button>
                                            </mat-menu>
                                        </div>
                                        <div class="flex flex-col space-y-2 primary-font text-base text-gray-700 font-normal">
                                            <span *ngIf="job?.job?.customer?.customer_first_name" class="mt-1">
                                                <i class="ti ti-user mr-2 text-2xl"></i>
                                                <span>{{job?.job?.customer?.customer_first_name}}
                                                    {{job?.job?.customer?.customer_last_name}}</span>
                                            </span>
                                            <span *ngIf="job?.job?.organization?.organization_name" class="mt-1">
                                                <i class="ti ti-building mr-2 text-2xl"></i>
                                                <span>{{job?.job?.organization?.organization_name}}</span>
                                            </span>
                                            <div class="flex my-1"
                                                *ngIf="job?.job?.scheduled_start_time && job?.job?.scheduled_end_time">
                                                <i class="ti ti-calendar-minus text-2xl"></i>
                                                <span class="text-base ml-1">{{job?.job?.scheduled_start_time | datetime: dateTimeFormat: timezone}} -
                                                    {{job?.job?.scheduled_end_time | datetime:dateTimeFormat : timezone}}</span>
                                            </div>
                                            <div class="flex my-1"
                                                *ngIf="!(job?.job?.scheduled_start_time && job?.job?.scheduled_end_time) && job?.job?.due_date">
                                                <i class="ti ti-calendar-minus text-2xl"></i>
                                                <span class="text-base ml-1">{{'text.due_by' | translate}}
                                                    {{job?.job?.due_date | datetime: dateTimeFormat: timezone}}</span>
                                            </div>
                                            <p *ngIf="job?.job?.customer_address?.street" class="mt-1">
                                                <i class="ti ti-map-pin mr-2 text-2xl"></i>
                                                <span class="text-base">{{job?.jobAddress}}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ng-container>
                    </ng-container>
                    <li class="mb-10 ml-6"
                        *ngIf="currentRoute?.end_location?.street || currentRoute?.end_location?.city">
                        <div class="text-base relative bottom-5"  *ngIf="currentRoute?.end_location?.street || currentRoute?.end_location?.city">
                            <span class="mr-3" *ngIf="currentRoute?.end_location?.distance">
                                <i class="ti ti-timeline text-2xl"></i>
                                <span *ngIf="companyConfig?.general?.distance_metric === 'MILES'">
                                    {{utilityService.getDistance(currentRoute?.end_location?.distance)}}
                                    {{'route.distance.metric.miles' | translate}}
                                </span>
                                <span *ngIf="companyConfig?.general?.distance_metric !== 'MILES'">
                                    {{utilityService.getDistance(currentRoute?.end_location?.distance)}}
                                    {{'route.distance.metric.kilo_meters' | translate}}
                                </span>
                            </span>
                            <em *ngIf="utilityService.getHours(currentRoute?.end_location?.time) || utilityService.getMin(currentRoute?.end_location?.time)"
                                class="ti ti-clock text-xl"></em>
                            <span class="text-base">
                                <span *ngIf="utilityService.getHours(currentRoute?.end_location?.time)">
                                    {{utilityService.getHours(currentRoute?.end_location?.time)}} {{'route.hours' | translate}}
                                </span>
                                <span *ngIf="utilityService.getMin(currentRoute?.end_location?.time)">
                                    {{utilityService.getMin(currentRoute?.end_location?.time)}} {{'route.min' | translate}}
                                </span>
                            </span>
                        </div>
                        <span
                            class="absolute flex items-center justify-center text-white w-6 h-6 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
                            [ngStyle]="{
                                        'background-color': currentRoute?.color
                                    }">
                            <i class="ti ti-player-stop"></i>
                        </span>
                        <div class="p-3 pt-4 border border-l-8 mb-6 relative cursor-pointer"
                            (click)="moveToLocation(currentRoute?.end_location)"
                            *ngIf="currentRoute?.end_location?.street" [ngStyle]="{
                                        'border-left-color': currentRoute?.color
                                    }">
                            <div>
                                <p class="text-base font-semibold">{{'text.end_location' | translate}}</p>
                                @if (currentRoute?.routeEndAddress) {
                                    <p class="text-base">{{currentRoute?.routeEndAddress}}</p>
                                }
                            </div>
                        </div>
                    </li>

                </ol>
            </div>
        </div>
    </div>
    <div class="route-detail-job-footer h-26 bg-gray-50 p-6 w-full grid" *ngIf="currentTab === 'JOBS'" [ngClass]="parentModule === 'dispatch' ? 'fixed bottom-0': 'relative'">
        <div class="flex justify-between items-center">
            <div>
                <div class="break-words" *ngIf="utilityService.getDistance(currentRoute?.total_distance)">
                    <em class="ti ti-timeline text-xl mr-1"></em>
                    <span class="text-base">
                        <span *ngIf="companyConfig?.general?.distance_metric === 'MILES'">
                            {{utilityService.getDistance(currentRoute?.total_distance)}} {{'route.distance.metric.miles'
                            | translate}}
                        </span>
                        <span *ngIf="companyConfig?.general?.distance_metric !== 'MILES'">
                            {{utilityService.getDistance(currentRoute?.total_distance)}}
                            {{'route.distance.metric.kilo_meters' | translate}}
                        </span>
                    </span>
                    <span class="text-base"
                        *ngIf="utilityService.getHours(currentRoute?.total_time) || utilityService.getMin(currentRoute?.total_time)">
                        (<span *ngIf="utilityService.getHours(currentRoute?.total_time)">
                            {{utilityService.getHours(currentRoute?.total_time)}} {{'route.hours' | translate}}
                        </span>
                        <span *ngIf="utilityService.getMin(currentRoute?.total_time)">
                            {{utilityService.getMin(currentRoute?.total_time)}} {{'route.min' | translate}}
                        </span>)
                    </span>
                </div>
                <div class="break-words flex items-center">
                    <em class="ti ti-briefcase text-xl mr-1"></em>
                    <span class="text-base">
                        {{currentRoute?.jobs?.length || 0}} {{'text.jobs' | translate}}
                    </span>
                    <span class="text-base"
                        *ngIf="getTotalScheduledDurationHours(totalJobDuration) || utilityService.getMin(totalJobDuration)">
                        (<span *ngIf="getTotalScheduledDurationHours(totalJobDuration)">
                            {{getTotalScheduledDurationHours(totalJobDuration)}} {{'route.hours' | translate}}
                        </span>
                        <span *ngIf="utilityService.getMin(totalJobDuration)">
                            {{utilityService.getMin(totalJobDuration * 60)}} {{'route.min' | translate}}
                        </span>)
                    </span>
                </div>
            </div>
            <div *ngIf="!currentRoute?.is_locked">
                <a mat-stroked-button (click)="toggleJob()"
                    class="inline-flex items-center px-4 py-3 h-9 border border-gray-300 shadow-xs text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none">
                    <em class="text-xl" class="ti ti-plus"></em><span
                        class="ml-2 primary-font text-base leading-loose pt-0.5">{{'route.add.job' | translate}}</span>
                </a>
            </div>
        </div>
    </div>
</div>

<zuper-drawer class="assign-employee" [fixed]="true" [mode]="'over'" [name]="'assignEmployeeDrawer'" [position]="'right'"
    [transparentOverlay]="false" [hideOnClickOutside]="false">
    <div class="w-full h-full" *ngIf="openEmployee">
        <zuper-assign-employee [options]="assignEmployeeOptions"
            (eventEmitter)="onAssignmentEventEmitted($event)"></zuper-assign-employee>
    </div>
</zuper-drawer>



<app-route-form [options]="routeEditFormOption" [drawerName]="'detailsEditRouteForm'" [openPicker]="openForm"
    *ngIf="parentModule !== 'dispatch'" [data]="currentRoute" [timezone]="timezone" [parentModule]="parentModule"
    (actionComplete)="onFormActionComplete($event)"></app-route-form>

<app-create-route-form  [options]="routeEditFormOption" [drawerName]="'detailsEditRouteForm'" [openPicker]="openForm"
    *ngIf="parentModule === 'dispatch'" [data]="currentRoute" [timezone]="timezone" [parentModule]="parentModule"
    (actionComplete)="onFormActionComplete($event)"></app-create-route-form>
  

<zuper-drawer class="job-reorder" [fixed]="true" [mode]="'over'" [name]="'reorderJobDrawer'" [position]="'right'"
    [transparentOverlay]="false" [hideOnClickOutside]="false">
    <div class="w-full h-full" *ngIf="openReorder">
        <div class="drawer-content w-full">
            <div class="route-form-header w-full">
                <div class="relative w-full px-4 py-2 bg-accent-100 dark:bg-accent-700 z-0">
                    <div class="flex items-center justify-between w-full">
                        <h5 class="text-2xl font-semibold">
                            {{'text.reorder_jobs' | translate}}
                        </h5>
                        <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                            matTooltipPosition="above" tabindex="0" (click)="closeReorderDrawer()">
                            <mat-icon [svgIcon]="'heroicons_solid:x'"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="route-main-container zuper-scrollbar">
                <div class="route-job-container">
                    <h5 class="my-3 flex items-center text-lg font-semibold text-gray-700 my-3">
                        <span class="ml-3">{{"text.jobs" | translate}}</span>
                    </h5>
                </div>
                <div class="m-4 border-l" [ngStyle]="{'border-left-color': preference?.scheduler?.secondary_color}">
                    <div class="p-3 pt-4 border border-l-8 mb-6" *ngIf="currentRoute?.start_location?.street" [ngStyle]="{
                            'background': preference?.scheduler?.primary_color,
                            'border-left-color': preference?.scheduler?.secondary_color
                        }">
                        <div>
                            <p class="text-base font-semibold">{{'text.start_location' | translate}}</p>
                            @if (currentRoute?.routeStartAddress) {
                                <p class="text-base">{{currentRoute?.routeStartAddress}}</p>
                            }
                        </div>
                    </div>
                    <app-job-reorder [jobs]="jobs" (reorderChange)="onReorderChange($event)" [canRemove]="false"
                        *ngIf="jobs?.length"></app-job-reorder>
                    <div class="p-3 pt-4 border border-l-8 mt-6" *ngIf="currentRoute?.end_location?.street" [ngStyle]="{
                            'background': preference?.scheduler?.primary_color,
                            'border-left-color': preference?.scheduler?.secondary_color
                        }">
                        <div>
                            <p class="text-base font-semibold">{{'text.end_location' | translate}}</p>
                            @if (currentRoute?.routeEndAddress) {
                                <p class="text-base">{{currentRoute?.routeEndAddress}}</p>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="route-footer h-16">
                <div class="w-full px-4 flex justify-between items-center gap-4 h-full">
                    <button mat-stroked-button (click)="closeReorderDrawer()"
                        class="h-10 min-h-10 px-6 w-full items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                        {{'cancel.text' | translate}}
                    </button>

                    <button type="button" (click)="updateReorderJobs()"
                        class="bg-primary w-full px-4 h-10 items-center py-2 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none">
                        <span>{{'text.reorder_jobs' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</zuper-drawer>

<data-picker (eventEmitter)="dataPickerEventHandler($event)" [openPicker]="openJob"
    [pickerDrawerName]="'details-picker'" [module]="'JOB'" [options]="jobPickerOptions"
    [filter]="getPickerFilter()" [timezone]="timezone"></data-picker>

<zuper-drawer class="assign-route-drawer" [fixed]="true" [mode]="'over'" [name]="'assignRoute'" [position]="'right'"
    [transparentOverlay]="false" [hideOnClickOutside]="false" (openedChanged)="assignRouteDrawerOpen($event)">
    <div class="h-full w-full">
        <div class="p-2 border-b border-gray-300 flex justify-between">
            <div class="primary-font font-bold text-lg text-gray-900 flex items-center pl-2">
                {{'team.delete.reassign.first.message' | translate}} - {{currentSelectedJob?.job_title}}
            </div>
            <div>
                <button type="button" mat-icon-button (click)="toggleDrawer('assignRoute')">
                    <em class="ti ti-x text-gray-900 text-xl"></em>
                </button>
            </div>
        </div>
        <div class="assign-route-drawer-component-height">
            <app-assign-route-component *ngIf="showAssignRoute" [routeSelected]="currentRoute?.route_uid"
                [date]="currentRouteDate"></app-assign-route-component>
        </div>
        <div class="absolute inset-x-0 bottom-0 border-t border-gray-200 px-4 py-5 sm:px-6">
            <div class="flex justify-end space-x-4 ml-auto">
                <button type="button" mat-stroked-button (click)="toggleDrawer('assignRoute')"
                    class="px-6 items-center py-2 btn-small border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">{{'cancel.text'
                    | translate}}</button>
                <button type="button" (click)="assignRoute()"
                    class="bg-primary primary-font btn-small px-6 flex items-center py-2 border shadow-sm text-white text-base font-medium rounded-md focus:outline-none">
                    {{'team.delete.reassign.first.message' | translate}}
                </button>
            </div>
        </div>
    </div>
</zuper-drawer>

<preview-data [previewDrawerName]="'routeJobPreview'" [drawerOpen]="openJobPreview" [module]="'JOB'"
    class="route-data-preview" [moduleUID]="currentJob?.job_uid" [options]="previewOptions"
    (eventEmitter)="previewDataEventHandler($event)">
</preview-data>